import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bind from 'lodash-decorators/bind';
import Debounce from 'lodash-decorators/debounce';

import { isOnMobile } from 'utils/device-utils';

import styles from './Filters.module.scss';

export default class FiltersComponent extends Component {
  static propTypes = {
    className: PropTypes.string,
    filters: PropTypes.oneOfType([PropTypes.array, PropTypes.string])
      .isRequired,
    onSelect: PropTypes.func,
    activeFilter: PropTypes.object.isRequired
  };

  static defaultProps = {
    className: '',
    filters: [],
    activeFilter: {}
  };

  state = {
    isMobile: isOnMobile()
  };

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  render() {
    const { className, filters, onSelect } = this.props;

    const desktopView = () =>
      filters.map((item, i) => (
        <h3
          key={i}
          onClick={() => {
            onSelect(item);
          }}
          className={`${styles.FiltersItem} ${
            this.isActive(item) ? styles.Active : ''
          }`}
        >
          {item.text}
        </h3>
      ));

    const mobileView = () => {
      const active = this.props.activeFilter.value.toString();

      return (
        <select
          className={styles.Select}
          onChange={this.onSelectMobile}
          defaultValue={active}
        >
          {filters.map((item, i) => (
            <option value={item.value} key={i}>
              {item.text}
            </option>
          ))}
        </select>
      );
    };

    return (
      <div className={` ${styles.Filters} ${className}`}>
        {this.state.isMobile ? mobileView() : desktopView()}
      </div>
    );
  }

  isActive(val) {
    return this.props.activeFilter.value === val.value;
  }

  @Bind()
  onSelectMobile(e) {
    const active = this.props.filters.find(
      filter => filter.value.toString() === e.target.value
    );
    this.props.onSelect(active);
  }

  @Bind()
  @Debounce(200)
  updateDimensions() {
    this.setState({
      isMobile: isOnMobile()
    });
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Filters/Filters.js